import common from "@page/common/js/common";
import Vue from "vue";
import Slick from "@global/vendors/vue-slick";

new Vue({
	el: "#story-slider",
	data: {
		storySliderConfig: {
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			speed: 800,
			responsive: [
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
			],
		},
	},
	mounted: function () {
		if ($(".story-slide").length) {
			$(".story-slide").slick(this.storySliderConfig);
			$("#story-slider").css("opacity", "1");
		}
	},
});

new Vue({
	el: "#trending-slider",
	data: {
		trendingSliderConfig: {
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			speed: 800,
			responsive: [
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
			],
		},
	},
	mounted: function () {
		if ($(".trending-slide").length) {
			$(".trending-slide").slick(this.trendingSliderConfig);
			$("#trending-slider").css("opacity", "1");
		}
	},
});

$(".secnav-right__search.show-mobile .global-search__btn").click(function (e) {
	e.preventDefault();
	const $header = $(".header");
	const headerHight = $header.height();
	if ($(window).scrollTop() < headerHight) {
		$header.toggleClass("active");
	}
	$(".search-form.mobile").toggleClass("open");
});

$(".secnav-right__burger").click(function (e) {
	e.preventDefault();
	$(".sidebar").addClass("active");
	$(".header").addClass("active");
	$(".secnav-right__cancel").css("display", "block");
	$(".secnav-right__burger").css("display", "none");
	$("body").toggleClass("lock-page");
});

$(".secnav-right__cancel").click(function (e) {
	e.preventDefault();
	$(".sidebar").removeClass("active");
	$(".secnav-right__cancel").css("display", "none");
	$(".secnav-right__burger").css("display", "block");
	$("body").toggleClass("lock-page");
});

$(".main-menu .shop").mouseenter(function (e) {
	e.preventDefault();
	const $header = $(".header");
	if ($(".nav__shop").css("opacity") !== 1 && !$header.hasClass("active")) {
		$header.addClass("active");
		console.log("ACTIVE header");
	}
});

$(".nav-item").mouseleave(function () {
	e.preventDefault();
	const $header = $(".header");
	const headerHight = $header.height();
	if ($(window).scrollTop() < headerHight) {
		$header.removeClass("active");
	}
});
$(document).ready(function () {
	function setNavShopOffset() {
		const leftWidth = "-" + ($(window).width() - 1920) / 2 + "px";
		var style = document.querySelector(".nav__shop").style;
		style.setProperty("--left", leftWidth);
	}
	const $header = $(".header");
	const headerHight = $header.height();
	if ($(window).width() > 1920) {
		setNavShopOffset();
	}
	if ($header.length < 1) return;

	function windowSize() {
		if ($(window).width() < 1200) {
			return true;
		}
	}

	$(window).resize(function () {
		windowSize();

		if ($(window).width() > 1920) {
			setNavShopOffset();
		}
	});

	$(window).scroll(function () {
		$(window).scrollTop() > headerHight ? $header.addClass("active") : $header.removeClass("active");
	});

	if (window.PictureContainer === "herbyh") {
		$("#page-index #bottom-bar").css("visibility", "hidden");
		$("#page-index #bottom-bar").css("height", "0px");
		$("#page-index #bottom-bar").css("padding", "0px");
	}
});

$("#mobile-global-search-btn").click(function (e) {
	const $inputVal = $("#mobile-global-search-input");
	if ($inputVal.val().length === 0) {
		AlertDialog.alert("請輸入關鍵字");
	} else {
		window.location.href = "/search?Keyword=" + $inputVal.val();
	}
});

$("#pc-global-search-input").on("keyup", function (event) {
	if (event.keyCode === 13) {
		const $inputVal = $("#pc-global-search-input");
		if ($inputVal.val().length === 0) {
			AlertDialog.alert("請輸入關鍵字");
		} else {
			window.location.href = "/search?Keyword=" + $inputVal.val();
		}
	}
});

$("#mobile-global-search-input").on("keyup", function (event) {
	if (event.keyCode === 13) {
		const $inputVal = $("#mobile-global-search-input");
		if ($inputVal.val().length === 0) {
			AlertDialog.alert("請輸入關鍵字");
		} else {
			window.location.href = "/search?Keyword=" + $inputVal.val();
		}
	}
});

$(".scroll-top").on("click", function (event) {
	$("html, body").on("scroll mousedown wheel DOMMouseScroll mousewheel keydown touchstart", function () {
		$("html, body").stop();
	});

	// 預設 500 毫秒
	$("html, body").animate({ scrollTop: 0 }, 800);
	event.preventDefault();
});
if ($(".index-popup").length) {
	if (!$(".index-popup").hasClass("show")) {
		$(".index-popup").addClass("show");
		$("body").addClass("modal-open");
		$("body").attr("data-aos-easing", "ease-in-out-sine");
		$("body").attr("data-aos-duration", "800");
		$("body").attr("data-aos-delay", "400");
	}
	$(".index-popup").click(function (e) {
		$(".index-popup").removeClass("show");
		$("body").removeClass("modal-open");
	});
	$(".modal-backdrop").click(function (e) {
		$(".index-popup").removeClass("show");
		$("body").removeClass("modal-open");
	});
}
